import { InfoIcon } from '@/assets/icons/info-icons/info';
import { Banner } from '@/components/basicComponents/banner';
import RadioButton from '@/components/basicComponents/radioButton';
import Label from '@/components/basicComponents/label';
import { useResponsive } from '@/hooks/use-responsive';
import { themeVar } from '@/styles/theme';
import { Control, Controller } from 'react-hook-form';
import styled from 'styled-components';

interface RadioButtonWithNotificationProps {
  control: Control<any>;
  name: string;
  label: string;
  options: string[];
  bannerDescription?: string;
}

export const RadioButtonWithNotification = ({ control, name, label, options, bannerDescription }: RadioButtonWithNotificationProps) => {
  const { isMobile } = useResponsive();

  return (
    <RadioButtonWithNotificationWrapper>
      <Label size="md">{label}</Label>
      <TwoColumnsWrapper isMobile={isMobile}>
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, value } }) => (
            <div>
              {options.map((option, index) => (
                <RadioButton
                  key={option + index}
                  name={name}
                  radioButtonText={option}
                  selectedOption={value}
                  handleRadioChange={(event) => onChange(event.target.value)}
                />
              ))}
            </div>
          )}
        />
        {bannerDescription && (
          <Banner
            icon={<InfoIcon fill={themeVar('menu.tab')} />}
            title=""
            description={bannerDescription}
            color={themeVar('font.base')}
            bgColor={themeVar('layer.base')}
            dividerColor={themeVar('border.base')}
            withBorderRadius
          />
        )}
      </TwoColumnsWrapper>
    </RadioButtonWithNotificationWrapper>
  );
};

const RadioButtonWithNotificationWrapper = styled.div`
  color: ${themeVar('font.base')};
`;

const TwoColumnsWrapper = styled.div<{ isMobile: boolean }>`
  display: grid;
  grid-template-columns: ${({ isMobile }) => (isMobile ? '1fr' : '1fr 1fr')};
  gap: ${({ isMobile }) => (isMobile ? '15px' : '30px')};
`;
